import * as Plotly from "plotly.js";

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import moment from "moment";
import { Signaltag } from "../../models/trend-live-models/OPTag";
import { map } from "rxjs/internal/operators/map";
import { forkJoin } from "rxjs/internal/observable/forkJoin";
import { Train } from "../../models";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { DEFAULT_TIME_FORMAT } from "../../models/trend-live-models/TimeRange";
import { PerformanceDetailsComponent } from "../performance-details/performance-details";
import { ModalController, NavParams } from "ionic-angular";
import { Observable, of } from "rxjs";
import { EntitiesProvider } from "../../providers/entities/entities";
/**
 * Generated class for the PerformanceGaugeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "performance-gauge",
  templateUrl: "performance-gauge.html",
})
export class PerformanceGaugeComponent {
  displayGauge = false;
  [x: string]: any;
  hasAGTPerformance;
  _train;
  nav;
  @ViewChild("chart", { read: ElementRef }) chartRef: ElementRef;
  performanceReady = false;
  agtDegradationLevels = [
    {
      tagName: "Deg_Level_1",
      tagId: null,
      startYellowBand: null,
    },
    {
      tagName: "Deg_Level_2",
      tagId: null,
      startRedBand: null,
    },
  ];

  agtPerformanceDegradation = [
    {
      tagName: "A54MW_D2MLM",
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
    {
      tagName: "A54MW_D2MLM_AVG",
      isStep: false,
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
  ];

  agtPerformanceAverage: any;
  agtPerformanceAdvise: string;
  constructor(
    private starms: StarmsClientProvider,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    private entitiesProvider: EntitiesProvider
  ) {
    this.nav = this.navParams.data;
    this._train = this.nav;
  }

  ngOnInit(): void {
    this._train = this.entitiesProvider.currentEntity as Train;
    this.getAGTPerformanceTags();
  }

  onPerformanceDetails() {
    this.modalCtrl
      .create(PerformanceDetailsComponent, {
        bandLimits: this.agtDegradationLevels,
        entity: this.nav,
        timeRange: this.timeRange,
        type: "Performance Degradation",
        agtTags: this.agtPerformanceDegradation,
        agtMeta: this.agtPerformanceMeta,
        message: this.agtPerformanceAdvise,
        lastTagValue: this.agtPerformanceAverage,
        lastDate: this.agtPerformanceDate,
      })
      .present();
  }
  //added 26 hours to the 'to' timestamp to cover all global time zones
  coverGlobalTimeZones(to: string) {
    let toDate = moment(to).add(26, "hours");
    let formattedToDate = toDate.format("YYYY-MM-DD HH:mm:ss");
    return formattedToDate;
  }
  private getTrainTags() {
    return this.starms
      .get(["signals", "signaltags", "trains", this._train.trainId])
      .pipe(
        map((response: any[]) => {
          return response.map((entry) => new Signaltag().deserialize(entry));
        })
      );
  }

  private getDegradationLimits() {
    this.getTrainTags().subscribe((tags) => {
      // Check performance tags availability
      if (tags) {
        const tagValues = this.getTagValues(tags, this.agtDegradationLevels);
        if (tagValues) {
          tagValues.subscribe(([tag1, tag2]) => {
            this.agtDegradationLevels[0].startYellowBand = tag1.tagData
              .filter((x) => x.value != null)
              .slice(-1)[0];
            this.agtDegradationLevels[1].startRedBand = tag2.tagData
              .filter((x) => x.value != null)
              .slice(-1)[0];
          });
        }
      }
    });
  }

  /**
   * Map agt perfromance tags to sta-rms tags
   */
  getAGTPerformanceTags() {
    this.getDegradationLimits();

    this.getTrainTags().subscribe((tags) => {
      // Check performance tags availability
      if (tags) {
        const tagValues = this.getTagValues(
          tags,
          this.agtPerformanceDegradation
        );
        if (tagValues) {
          tagValues.subscribe(([tag1, tag2]) => {
            this.agtPerformanceDegradation[0].tagData = tag1.tagData;
            this.agtPerformanceDegradation[0].tagDescription =
              tag1.tagIndex.description;

            this.agtPerformanceDegradation[1].tagData = tag2.tagData;
            this.agtPerformanceDegradation[1].tagDescription =
              tag2.tagIndex.description;
            this.agtPerformanceDegradation[1].isStep = tag2.step;

            let agtPerformance = tag2.tagData
              .filter((x) => x.value != null)
              .slice(-1)[0];

            if (agtPerformance == null) {
              this.agtPerformanceAverage = null;
            } else {
              this.agtPerformanceAverage =
                Math.round(agtPerformance.value * 10) / 10;
              this.agtPerformanceDate = moment
                .utc(agtPerformance.timestamp)
                .format("DD-MMM-YYYY HH:mm");
            }

            this.agtPerformanceFirstValue = tag2.tagData.find(
              (x) => x.value !== null
            ).value;

            if (
              tag2 &&
              this.agtDegradationLevels[0].startYellowBand &&
              this.agtDegradationLevels[1].startRedBand
            ) {
              this.getGaugeData(tag2, this.agtDegradationLevels);
            }

            this.agtLoading = false;
          });
        }
      }
    });

    //});
  }

  private getGaugeData(tag2: Signaltag, degradationLevels) {
    var redBottom =
      degradationLevels[1].startRedBand.value <
      Math.min(...tag2.tagData.map((x) => x.value))
        ? degradationLevels[1].startRedBand.value - 2000
        : Math.min(...tag2.tagData.map((x) => x.value)) - 2000;
    var yellowBottom = degradationLevels[1].startRedBand.value;
    var yellowTop = degradationLevels[0].startYellowBand.value;
    var greenTop =
      degradationLevels[0].startYellowBand.value >
      Math.max(...tag2.tagData.map((x) => x.value))
        ? degradationLevels[0].startYellowBand.value + 2000
        : Math.max(...tag2.tagData.map((x) => x.value)) + 2000;
    if (this.agtPerformanceAverage == null) {
      this.agtPerformanceAdvise = "";
    } else {
      if (
        this.agtPerformanceAverage > degradationLevels[1].startRedBand.value &&
        this.agtPerformanceAverage < degradationLevels[0].startYellowBand.value
      ) {
        let decreasedValue =
          this.agtPerformanceFirstValue - this.agtPerformanceAverage;
        this.agtPerformanceAdvise =
          "Your performance decreased " +
          Math.round(decreasedValue * 10) / 10 +
          " kW in the last year";
        this.performWashAdvise = "yellow";
      } else if (
        this.agtPerformanceAverage < degradationLevels[1].startRedBand.value
      ) {
        this.agtPerformanceAdvise = "Compressor wash advised";
        this.performWashAdvise = "red";
      } else {
        this.agtPerformanceAdvise =
          "Engine is running as expected with no appreciable degradation";
        this.performWashAdvise = "green";
      }
    }

    if (this.agtPerformanceAverage && this.agtPerformanceAdvise) {
      this.createPerformanceDetChart(
        this.agtPerformanceAverage,
        Math.round(redBottom * 10) / 10,
        Math.round(yellowBottom * 10) / 10,
        Math.round(yellowTop * 10) / 10,
        Math.round(greenTop * 10) / 10
      );
    }
  }

  private getTagValues(tags: Signaltag[], degradationArray): Observable<any> {
    for (let agtTag of degradationArray) {
      let index = tags.findIndex((tag) => tag.tagName === agtTag.tagName);
      if (index > -1) {
        agtTag.tagId = tags[index].tagId;
      } else return;
    }
    if (degradationArray.filter((tag) => tag.tagId !== undefined).length > 1) {
      this.hasAGTPerformance = true;
    }
    // Get each performance tag values
    return forkJoin(
      ...degradationArray.map((agtTag) => {
        return this.starms.get(["signals/tags", agtTag.tagId], {
          filter: "optim",
          // added 26 hours to the 'to' timestamp to cover all global time zones
          to: this.coverGlobalTimeZones(moment().toString()),
          from: moment().subtract(1, "years").format("YYYY-MM-DD HH:mm:ss"),
        });
      })
    ).pipe(
      map((rawTags: any[]) => {
        return [
          ...rawTags.map((rawTag) => {
            let tag = new Signaltag().deserialize(rawTag);
            return tag;
          }),
        ];
      })
    );
  }

  createPerformanceDetChart(
    value: number,
    redBottom: number,
    yellowBottom: number,
    yellowTop: number,
    greenTop: number
  ) {
    var data = [
      {
        type: "indicator",
        mode: "gauge+number",
        value: value,
        number: {
          suffix: " kW",
          font: { size: 30, family: "Siemens Slab", weight: 900 },
          valueformat: "." + 1 + "f",
        },
        //title: { text: "Power Availability", font: { size: 21 } },
        // delta: { reference: -2543, increasing: { color: "#4d217a" } },
        title: {
          text:
            "<span style='font-size:14px; color:black;'>" +
            moment(this.agtPerformanceDate).format("MMM Do, yyyy, h:mm:ss a") +
            "</span>",
        },
        // title: {'text': "<span style='font-size:15; color:black'>" + "</span>"},
        gauge: {
          axis: {
            range: [redBottom, greenTop],
            tickwidth: 1,
            tickcolor: "white",
            tickvals: [redBottom, yellowBottom, yellowTop, greenTop],
            ticktext: [redBottom, yellowBottom, yellowTop, greenTop],
            tickmode: "array",
          },

          bar: { color: "#4D217A" },
          bgcolor: "white",
          borderwidth: 1,
          bordercolor: "black",
          steps: [
            {
              range: [redBottom, yellowBottom],
              color: "#f5c6c9",
              opacity: 0.2,
            }, // red - #DA1E28
            {
              range: [yellowBottom, yellowTop],
              color: "#fffdc6",
              opacity: 0.2,
            }, // yellow - #FFF91F
            { range: [yellowTop, greenTop], color: "#bffedd", opacity: 0.2 }, // green - #00FD79
          ],
          threshold: {
            line: { color: "white", width: 4 },
            thickness: 0.75,
            value: 490,
          },
        },
      },
    ];

    var layout = {
      width: 350,
      height: 210,
      margin: { t: 50, r: 80, l: 45, b: 0, pad: 0 },
      paper_bgcolor: "white",
      font: { color: "black", family: "Siemens Slab" },
    };

    var config = {
      responsive: true,
      displayModeBar: false,
    };

    if (value !== null) {
      this.performanceReady = true;

      Plotly.newPlot("chart", data, layout, config);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/performance-gauge/performance-gauge.ts